module.exports = __webpack_public_path__ + "static/media/twitterRounded.a59d3dd6.svg";